import { loadStripe } from "@stripe/stripe-js";

let stripe;

export async function getStripe() {
  if (!stripe) {
    stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
      apiVersion: "2020-08-27",
    });
  }
  return stripe;
}